import { getBasketId } from './getBasket';

export const REMOVE_FROM_BASKET_STORE_PATH = 'checkout/baskets/[BASKET_ID]/products/[PRODUCT_ID]';
export const BUNDLES_API_STORE_PATH = 'checkout/baskets/[BASKET_ID]/bundles';

const isValidRemoveFromBasketResponse = (response) => response.error === undefined;

export const removeMainProductFromBasket = async (storeUrl, basketId, productId) => {
  const removeFromBasketUrl = `${storeUrl}/${REMOVE_FROM_BASKET_STORE_PATH}`
    .replace('[BASKET_ID]', basketId)
    .replace('[PRODUCT_ID]', productId);
  let removeFromBasketResponse;
  try {
    removeFromBasketResponse = await fetch(removeFromBasketUrl, {
      method: 'DELETE',
      credentials: 'include'
    });
  } catch (e) {
    throw new Error(
      'There was an error removing the main product'
    );
  }
  const removeFromBasketResponseJSON = await removeFromBasketResponse.json();
  if (isValidRemoveFromBasketResponse(removeFromBasketResponseJSON)) {
    return removeFromBasketResponseJSON;
  }
  throw new Error(
    'There was an unknown error removing the main product'
  );
};

const generateRandomBundleId = () => {
  const min = 10000000;
  const max = 99999999;
  // eslint-disable-next-line no-mixed-operators
  return `D${(Math.floor(Math.random() * (max - min + 1)) + min).toString()}`;
};

export const addBundleToBasket = async (storeUrl, mainProductId, attachmentId) => {
  const basketId = await getBasketId(storeUrl);
  if (!basketId) {
    throw new Error(
      'Could not add bundle to basket. Basket ID could not be fetched.'
    );
  }
  try {
    await removeMainProductFromBasket(storeUrl, basketId, mainProductId);
  } catch (e) {
    throw new Error(
      'Could not add bundle to basket. Main product could not be removed.'
    );
  }
  const bundleToBasketUrl = `${storeUrl}/${BUNDLES_API_STORE_PATH}`
    .replace('[BASKET_ID]', basketId);
  const bundleComposition = {
    mainProduct: {
      bundleProductId: mainProductId,
      quantity: 1,
      isMain: true
    },
    attachmentProduct: {
      bundleProductId: attachmentId,
      quantity: 1,
      isMain: false
    }
  };
  const formData = new FormData();
  // TODO - increment bundleId - must be stored in session
  const bundleId = generateRandomBundleId();
  formData.append('bundleId', bundleId);
  // eslint-disable-next-line max-len
  formData.append('bundleComposition[0][bundleProductId]', bundleComposition.mainProduct.bundleProductId);
  formData.append('bundleComposition[0][quantity]', bundleComposition.mainProduct.quantity);
  formData.append('bundleComposition[0][isMain]', bundleComposition.mainProduct.isMain);
  // eslint-disable-next-line max-len
  formData.append('bundleComposition[1][bundleProductId]', bundleComposition.attachmentProduct.bundleProductId);
  formData.append('bundleComposition[1][quantity]', bundleComposition.attachmentProduct.quantity);
  formData.append('bundleComposition[1][isMain]', bundleComposition.attachmentProduct.isMain);
  let response;
  try {
    response = await fetch(bundleToBasketUrl, {
      method: 'POST',
      credentials: 'include',
      body: formData
    });
  } catch (e) {
    throw new Error(
      'Could not add bundle to basket. Request failed.'
    );
  }

  return response;
};
